var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing",attrs:{"id":"homeLanding"}},[_c('ScrollupSection'),_c('div',{staticClass:"main"},[_c('HeaderSection'),_c('HeroSection'),_c('FeatureSection'),_c('VideoSection'),_c('FooterSection')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }